import { PostHogConfig, posthog } from 'posthog-js';

import { loadContext } from 'src/api/loaders';
import type { User } from 'src/api/models';

interface PosthogContext {
  posthogApiKey: string;
  user: User | undefined;
}

export function loadPosthog() {
  const options: Partial<PostHogConfig> = {
    api_host: 'https://app.posthog.com',
    disable_session_recording: true,
    session_recording: {
      recordCrossOriginIframes: true,
    },
    loaded: (posthog) => {
      const enabled = Math.floor(Math.random() * 100);
      // Enable for 1 in 100 or if path is video-embed
      if (enabled === 0 || window.location.pathname.includes('/videos-embed')) {
        posthog.startSessionRecording();
      }
    },
  };
  const context = loadContext<PosthogContext>();
  posthog.init(context.posthogApiKey, options);
  if (context.user) {
    posthog.identify(context.user.id.toString(), {
      email: context.user.email,
      firstName: context.user.firstName,
      username: context.user.username,
    });
  }
}
